import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, operator, loading, error, passwordSetupRequired } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="full-screen-center">Loading…</div>;
  }
  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Invitee / password-reset session — gate the app until they set a password.
  if (passwordSetupRequired && location.pathname !== '/set-password') {
    return <Navigate to="/set-password" replace />;
  }
  if (!operator) {
    // Signed in but no linked operator row. Surface the error and offer logout.
    return (
      <div className="full-screen-center">
        <div className="error-card">
          <h2>No operator profile</h2>
          <p>{error ?? 'Your account is not linked to an active operator.'}</p>
          <a className="btn-link" href="/login">Sign out and try again</a>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
